<template>
  <div class="about-us-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <div class="title-1">
            <p class='title-1-1'>Who We Are</p>
            <p class="title-1-2">Pioneering the Future of AI Governance & Strategy</p>
          </div>
          
          <div class="hero-box">
             <div class="hero-text1">
              <p>AI Without Borders is a premier strategic advisory firm dedicated to bridging the gap between rapid AI advancement and sustainable global development. We empower nations and organizations to navigate the complexities of the artificial intelligence era with confidence and foresight.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="mission">
      <div class="container">
        <div class="mission-content">
          <h2>Our Mission</h2>
          <p>Our mission is to democratize access to artificial intelligence strategy and governance, ensuring that the benefits of AI are shared globally. We strive to build a future where technology serves humanity without borders.</p>
          <p>We partner with governments, international organizations, and industry leaders to craft bespoke AI strategies that drive innovation while mitigating risks. Our approach is holistic, combining technical expertise with deep policy insight.</p>
        </div>
      </div>
    </section>

    <section class="team">
      <div class="container">
        <h2>Meet Our Team</h2>
        <div class="team-members">
          <div class="team-member">
            <img src="@/assets/images/team-member.jpg" alt="Team Member" />
            <h3>John Smith</h3>
            <p>Founder & CEO</p>
          </div>
          <div class="team-member">
            <img src="@/assets/images/team-member.jpg" alt="Team Member" />
            <h3>Jane Doe</h3>
            <p>Operations Director</p>
          </div>
          <div class="team-member">
            <img src="@/assets/images/team-member.jpg" alt="Team Member" />
            <h3>Michael Johnson</h3>
            <p>Technology Lead</p>
          </div>
        </div>
      </div>
    </section>

    <section class="values">
      <div class="container">
        <h2>Our Values</h2>
        <div class="values-list">
          <div class="value">
            <h3>Expertise</h3>
            <p>Deep industry knowledge and specialized skills.</p>
          </div>
          <div class="value">
            <h3>Integrity</h3>
            <p>Honest, transparent partnerships with our clients.</p>
          </div>
          <div class="value">
            <h3>Innovation</h3>
            <p>Forward-thinking solutions for modern challenges.</p>
          </div>
          <div class="value">
            <h3>Results</h3>
            <p>Measurable impact and sustainable growth.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AboutUsPage'
}
</script>

<style scoped>
.about-us-page {
  background-color: rgb(2, 2, 2); /* Match Home Page Dark Theme */
  min-height: 100vh;
  color: white;
}

.hero {
  background-image: url('@/assets/无国界切图/who we are@1x.png');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0;
  padding-top: calc(8rem + 100px);
  text-align: center;
  position: relative;
  width: 100%;
  min-height: 600px; /* Adjusted height */
  display: flex;
  align-items: center;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.4);  Optional overlay if needed for readability */
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Left align like Home Page */
  text-align: left;
}

.title-1 {
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.title-1-1 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 48px; /* Larger Title */
  line-height: 1.2;
  margin: 0;
  background: linear-gradient(313deg, #59D8AA 0%, #81E1F9 53%, #FFFFFF 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.title-1-2 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 24px;
  color: #FFFFFF;
  margin: 0;
}

.hero-box {
  width: 100%;
  max-width: 800px;
}

.hero-text1 p {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 1.6;
  opacity: 0.9;
}

.mission {
  background-color: var(--bg-light);
  color: black;
  padding: 6rem 0;
}

.mission-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
}

.mission h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
}

.mission p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

.team {
  background-color: black;
  color: white;
  padding: 6rem 0;
}

.team h2 {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
}

.team-members {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 1rem;
}

.team-member {
  text-align: center;
}

.team-member img {
  width: 100%;
  max-width: 300px;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.team-member h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.team-member p {
  color: #aaa;
  font-size: 1rem;
}

.values {
  background-color: var(--bg-light);
  color: black;
  padding: 6rem 0;
}

.values h2 {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
}

.values-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 0 1rem;
}

.value h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.value p {
  font-size: 1rem;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .title-1-1 {
    font-size: 32px;
  }
  
  .title-1-2 {
    font-size: 18px;
  }
  
  .mission h2, .team h2, .values h2 {
    font-size: 2rem;
  }
}
</style>